import React, { FC, SVGProps } from 'react'
import styled from 'styled-components'

import { SVGIcon } from '@Components/Icons'
import { flexCenterChildren, sectionOuter } from '@Globals/Style/mixins'

import type { ShipmentNotificationBarProps, TimeGatedShipmentNotificationBarProps } from './types'

interface IconProps {
  icon: FC<SVGProps<SVGSVGElement>>
}
interface WrapperProps extends Pick<ShipmentNotificationBarProps, 'background' | 'color'> {}

const Wrapper = styled.section<WrapperProps>`
  ${flexCenterChildren}
  ${sectionOuter}
  background-color: ${({ background, theme }) => theme.colors[background]};
  padding: 5px 20px;
  text-align: center;

  .text {
    color: ${({ color, theme }) => theme.colors[color]};
    display: block;
    font-size: 0.875rem;
  }
`

const StyledIcon = styled.div`
  display: inline-block;
  height: 1rem;
  margin: 0 10px;
  width: 1rem;
`

const Icon: FC<IconProps> = ({ icon }: IconProps) => (
  <StyledIcon>
    <SVGIcon icon={icon} size="16px" />
  </StyledIcon>
)

export const ShipmentNotificationBar: FC<ShipmentNotificationBarProps> = ({
  background,
  children,
  className,
  color,
  icon,
}: ShipmentNotificationBarProps) => (
  <Wrapper background={background} className={className} color={color}>
    {icon && <Icon icon={icon} />}
    <span className="text">{children}</span>
    {icon && <Icon icon={icon} />}
  </Wrapper>
)

export const TimeGatedShipmentNotificationBar: FC<TimeGatedShipmentNotificationBarProps> = ({
  endDate,
  startDate,
  ...barProps
}: TimeGatedShipmentNotificationBarProps) => {
  const now = new Date()

  if (startDate > now || now > endDate) {
    return null
  }

  return <ShipmentNotificationBar {...barProps} />
}
